import { __makeTemplateObject } from "tslib";
import React, { memo } from 'react';
import { stylesFactory, useTheme } from '../../themes';
import { getColorForTheme } from '@grafana/data';
import { css } from 'emotion';
import tinycolor from 'tinycolor2';
var nodeR = 40;
var getStyles = stylesFactory(function (theme) { return ({
    mainGroup: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    cursor: pointer;\n    font-size: 10px;\n  "], ["\n    cursor: pointer;\n    font-size: 10px;\n  "]))),
    mainCircle: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    fill: ", ";\n  "], ["\n    fill: ", ";\n  "])), theme.colors.panelBg),
    hoverCircle: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    opacity: 0.5;\n    fill: transparent;\n    stroke: ", ";\n  "], ["\n    opacity: 0.5;\n    fill: transparent;\n    stroke: ", ";\n  "])), theme.colors.textBlue),
    text: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    fill: ", ";\n  "], ["\n    fill: ", ";\n  "])), theme.colors.text),
    titleText: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    text-align: center;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n    background-color: ", ";\n  "], ["\n    text-align: center;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n    background-color: ", ";\n  "])), tinycolor(theme.colors.bodyBg).setAlpha(0.6).toHex8String()),
}); });
export var Node = memo(function Node(props) {
    var node = props.node, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onClick = props.onClick, hovering = props.hovering;
    var styles = getStyles(useTheme());
    if (!(node.x !== undefined && node.y !== undefined)) {
        return null;
    }
    return (React.createElement("g", { className: styles.mainGroup, onMouseEnter: function () {
            onMouseEnter(node.id);
        }, onMouseLeave: function () {
            onMouseLeave(node.id);
        }, onClick: function (event) {
            onClick(event, node);
        }, "aria-label": "Node: " + node.title },
        React.createElement("circle", { className: styles.mainCircle, r: nodeR, cx: node.x, cy: node.y }),
        hovering && React.createElement("circle", { className: styles.hoverCircle, r: nodeR - 3, cx: node.x, cy: node.y, strokeWidth: 2 }),
        React.createElement(ResponseTypeCircle, { node: node }),
        React.createElement("g", { className: styles.text },
            React.createElement("text", { x: node.x, y: node.y - 5, textAnchor: 'middle' }, node.mainStat),
            React.createElement("text", { x: node.x, y: node.y + 10, textAnchor: 'middle' }, node.secondaryStat),
            React.createElement("foreignObject", { x: node.x - 50, y: node.y + nodeR + 5, width: "100", height: "30" },
                React.createElement("div", { className: styles.titleText },
                    node.title,
                    React.createElement("br", null),
                    node.subTitle)))));
});
/**
 * Shows the outer segmented circle with different color for each response type.
 */
function ResponseTypeCircle(props) {
    var node = props.node;
    var fullStat = node.arcSections.find(function (s) { return s.value === 1; });
    var theme = useTheme();
    if (fullStat) {
        // Doing arc with path does not work well so it's better to just do a circle in that case
        return (React.createElement("circle", { fill: "none", stroke: getColorForTheme(fullStat.color, theme), strokeWidth: 2, r: nodeR, cx: node.x, cy: node.y }));
    }
    var nonZero = node.arcSections.filter(function (s) { return s.value !== 0; });
    var elements = nonZero.reduce(function (acc, section) {
        var el = (React.createElement(ArcSection, { key: section.color, r: nodeR, x: node.x, y: node.y, startPercent: acc.percent, percent: section.value, color: getColorForTheme(section.color, theme), strokeWidth: 2 }));
        acc.elements.push(el);
        acc.percent = acc.percent + section.value;
        return acc;
    }, { elements: [], percent: 0 }).elements;
    return React.createElement(React.Fragment, null, elements);
}
function ArcSection(_a) {
    var r = _a.r, x = _a.x, y = _a.y, startPercent = _a.startPercent, percent = _a.percent, color = _a.color, _b = _a.strokeWidth, strokeWidth = _b === void 0 ? 2 : _b;
    var endPercent = startPercent + percent;
    var startXPos = x + Math.sin(2 * Math.PI * startPercent) * r;
    var startYPos = y - Math.cos(2 * Math.PI * startPercent) * r;
    var endXPos = x + Math.sin(2 * Math.PI * endPercent) * r;
    var endYPos = y - Math.cos(2 * Math.PI * endPercent) * r;
    var largeArc = percent > 0.5 ? '1' : '0';
    return (React.createElement("path", { fill: "none", d: "M " + startXPos + " " + startYPos + " A " + r + " " + r + " 0 " + largeArc + " 1 " + endXPos + " " + endYPos, stroke: color, strokeWidth: strokeWidth }));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=Node.js.map